/**
 * 0.  新用户
 * 1.  基本版 - C端免费注册账户，不显示到期时间
 * 2.  高级版（专业版） - 付费高级版，显示到期时间，过期后变为基本版
 * 3.  未验证邮件
 * 4.  VIP 高级版(非付费) - 非付费升级高级版，显示到期时间，过期后变为基本版
 * 5.  教育版 基本版 - 教育版 高级版”到期后，展示为“教育版 基本版”，
 * 6.  教育版 高级版 - 教育版升级用户，显示到期时间，过期后显示为“教育版 基本版”
 * 7.  企业版
 * 8.  企业版 试用版
 * 9.  商用版
 * 10. 商用版 试用
 * 11. 企业版 通用版
 * 12. 机构版
 * 13. 机构版 通用版
 */
export enum VERSION_TYPE {
    NEW_ACCOUNT = 0,
    NORMAL = 1,
    ENTERPRISE = 7,
    ENTERPRISE_TRIAL = 8,
    COMMERICAL = 9,
    COMMERICAL_TRIAL = 10,
    ENTERPRISE_COMMON = 11,
    INSTITUTE = 12,
    INSTITUTE_COMMON = 13,
}

export interface IAccountPlan {
    account_quota: number;
    business_free_trial: number;
    expire_days: number;
    expire_time: number;
    plan_id: number;
    teacher_status: VERSION_TYPE;
    used_account_quota: number;
    /**
     * 是否需要给与过期提示
     */
    show_trial_overdue_dialog: 0 | 1;
}